<template>
  <div style="width: 100%;">
    <div class="action-lists">
      <el-tabs v-model="activeName" @tab-click="showOther" style="width: 100%;">
        <el-tab-pane label="推广计划" name="plan"></el-tab-pane>
        <el-tab-pane label="推广组" name="group"></el-tab-pane>
        <el-tab-pane label="推广单元" name="adv"></el-tab-pane>
      </el-tabs>
      <div class="table">
        <div class="btns">
          <el-button type="primary" icon="fa fa-plus-circle" @click="add()" size="small" style="margin-right: 20px;"> 新建广告计划</el-button>
          <div class="demo-input-suffix">
            <el-input placeholder="请输入关键词" v-model="keyword" size="small" style="width: 350px;" show-word-limit maxlength="32">
                <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
              </el-input>
          </div>
        </div>
        <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @select="selectRow" @select-all="selectAll">
            <el-table-column label="开关" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="推广计划名称" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column prop="total_title" label="总预算"></el-table-column>
            <el-table-column prop="budget_title" label="每日限额"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === false">暂停</span>
                <span style="color: red;" v-else>启动</span>
              </template>
            </el-table-column>
            <el-table-column prop="start_time" label="计划开始时间"></el-table-column>
            <el-table-column prop="end_time" label="计划结束时间"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edit(scope.$index)">编辑</el-button>
                <el-button type="text" size="mini" @click="delOne(scope.row.plan_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page-c">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      keyword: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: [],
      activeName: 'plan',
      options: [{
        value: '0',
        label: '暂停'
      }, {
        value: '1',
        label: '启动'
      }],
      options1: [{
        value: '0',
        label: '线索收集'
      }, {
        value: '1',
        label: '应用推广'
      }],
      status: '', // 状态搜索
      purpose: '' // 目的搜索
    };
  },
  created() {
    this.$function.hiddenLoading();
    this.getData();
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getPlanLists', {
        purpose: this.purpose,
        status: this.status,
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    add() {
      this.$emit('jump_form_plan', []);
    },
    selectRow(sel, row) {
      const selected = sel.length && sel.indexOf(row) !== -1;
      if (selected) {
        if (this.ids.indexOf(row.plan_id) === -1) {
          this.ids.push(row.plan_id);
        }
      } else {
        if (this.ids.indexOf(row.plan_id) !== -1) {
          this.ids.splice(this.ids.indexOf(row.plan_id), 1);
        }
      }
    },
    selectAll(sel) {
      if (sel.length > 0) {
        this.ids = [];
        for (var i = 0; i < sel.length; i++) {
          this.ids.push(sel[i].plan_id);
        }
      } else {
        this.ids = [];
      }
    },
    showOther() {
      this.$emit('showOther', this.activeName);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].plan_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changePlanStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    edit(index) {
      this.$emit('jump_form_plan', this.tableData[index]);
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delPlan', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped="">
  .action-lists {
    background: #fff;
    width: calc(100% - 32px);
    padding: 24px 16px;
    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: 100%;
    .make {
      padding: 20px 0;
    }
    .btns {
      margin-bottom: 16px;
      color: #606266;
      font-size: 14px;
      .demo-input-suffix {
        display: inline-block;
        margin-right: 16px;
      }
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>
